import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grid m-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-0 flex justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "font-light mb-0 mt-0" }, "Bookmarks")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Internal error ")
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "col-12 mb-0 flex justify-content-center border-bottom-1 border-200 pt-0 pb-10" }
const _hoisted_5 = { class: "grid m-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "xl:col-3" }, null, -1)
const _hoisted_7 = { class: "p-0 col-12 xl:col-6" }
const _hoisted_8 = { class: "flex flex-column border-right-1 border-left-1 border-bottom-1 border-300" }

import NavBar from "@/components/NavBar.vue";
import { useQuery } from "@vue/apollo-composable";
import router from "../router";
import { useRoute } from "vue-router";
import gql from "graphql-tag";
import PostList from "@/components/post/PostList.vue";
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
import { Bookmark } from "@/models/bookmark";


export default /*#__PURE__*/_defineComponent({
  emits: ["on-router-view-reload"],
  setup(__props, { emit }) {



const route = useRoute();
const currentPage = parseInt(route.query.p?.[0]!)
const rowsPerPage = parseInt(localStorage.getItem("postNbOption") || '25');
const posts = ref([]);

if (isNaN(currentPage) || currentPage < 1) {
  router.push(`/bookmarks?p=1`);
}

const variables = ref({
  limit: rowsPerPage,
  offset: (currentPage - 1) * rowsPerPage,
});

const { result, loading, error, refetch, onResult } = useQuery(
  gql`
    query getPosts($limit: Int, $offset: Int) {
      bookmark_aggregate {
        aggregate {
          count
        }
      }
      bookmark(order_by: { created_at: desc }, limit: $limit, offset: $offset) {
        post {
          url
          uuid
          created_at
          description
          title
          user {
            id
            username
          }
          comments_aggregate {
            aggregate {
              count
            }
          }
          post_tags(order_by: {tag: {name: asc}}) {
            tag {
              name
            }
          }
          bookmarks {
            uuid
          }
        }
      }
    }
  `,
  variables,
  {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  }
);

onResult(({ data }) => posts.value = data.bookmark.map((bookmark: Bookmark) => bookmark.post))

watch(result, (value) => {
  if (
    value &&
    currentPage >
    Math.ceil(value.bookmark_aggregate.aggregate.count / rowsPerPage)
  ) {
    router.push(`/bookmarks?p=1`);
  }
});

const changePage = ({ page }: { page: number }) => {
  router.push(`/bookmarks?p=${page + 1}`);
};

const updatePostNb = () => {
  emit('on-router-view-reload')
}

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    _hoisted_1,
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "mt-5",
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : (_unref(result))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_unref(result).bookmark_aggregate.aggregate.count) + " bookmark" + _toDisplayString(_unref(result).bookmark_aggregate.aggregate.count !== 1 ? "s" : ""), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).bookmark_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[0] || (_cache[0] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"]),
                    _createVNode(PostList, {
                      posts: posts.value,
                      onOnRefresh: _unref(refetch),
                      onOnPostNbChange: updatePostNb
                    }, null, 8, ["posts", "onOnRefresh"]),
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).bookmark_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[1] || (_cache[1] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})